import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConsentBannerComponent} from './consent-banner.component';
import {TuiButtonModule, TuiSvgModule} from '@taiga-ui/core';
import {TuiToggleModule} from '@taiga-ui/kit';
import {ReactiveFormsModule} from '@angular/forms';
import {CoreModule} from '@core/core.module';
import {IconModule} from '@tisa-group/client-ui';

@NgModule({
  declarations: [ConsentBannerComponent],
  imports: [
    CommonModule,
    TuiButtonModule,
    TuiToggleModule,
    ReactiveFormsModule,
    CoreModule,
    TuiSvgModule,
    IconModule,
  ],
  exports: [ConsentBannerComponent],
})
export class ConsentBannerModule {}
